import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import * as Ant from 'antd';
import {ArrowLeftShort} from '@styled-icons/bootstrap/ArrowLeftShort';
import {Share} from '@styled-icons/material/Share';
import useDocuments from '../../Hooks/useDocuments';
import Breadcrumb from '../../Components/Breadcrumb';
import {Link} from 'gatsby';
import ShareSection from '../../Components/ShareSection';
import useArea from '../../Hooks/useArea';

const collection = 'activity';

function Activities(props) {
  const [record, setRecord] = React.useState();
  const {id} = qs.parse(props.location.search);
  const {isDoctorByPathname} = useArea();
  const isDoctor = isDoctorByPathname(props.location.pathname);

  const {records, refresh, filters, setFilters, total} = useDocuments({
    defaultFilters: {
      ...(isDoctor ? {doctor_area: true} : {public_area: true}),
    },
    collection,
    projection: {richtext: 0, raw_html: 0},
    sorting: ['-start_date'],
  });

  React.useEffect(() => {
    async function fetchData() {
      AppActions.setLoading(true);
      try {
        setRecord(
          await JStorage.fetchOneDocument(
            collection,
            {
              id: id || '-',
              ...(isDoctor ? {doctor_area: true} : {public_area: true}),
            },
            null,
          ),
        );
      } catch (ex) {
        console.warn('REV_DBG', ex);
      }
      AppActions.setLoading(false);
    }

    if (id) {
      fetchData();
    }
  }, [id, isDoctor]);

  React.useEffect(() => {
    if (!id) {
      setRecord(null);
      refresh();
    }
  }, [id, refresh]);

  return (
    <Wrapper>
      <main className="tda-layout">
        <section className="content">
          {id && record ? (
            <React.Fragment>
              <div className="tda-header">
                <h2>活動花絮</h2>
                <Breadcrumb />
              </div>

              {record && (
                <>
                  <div className="tda-detail-title">
                    <h1 style={{fontSize: 26}}>{record.title}</h1>

                    <div style={{color: 'var(--primaryColor)'}}>
                      {record.start_date} ~ {record.end_date}
                    </div>
                  </div>

                  <section className="document">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: record.raw_html?.enabled
                          ? record.raw_html.html
                          : record.richtext?.html
                          ? record.richtext?.html
                          : record.html,
                      }}
                    />
                  </section>

                  {record.url && (
                    <section className="link">
                      <Share size={16} style={{marginRight: 10}} />
                      <a href={record.url} target="_blank" rel="noreferrer">
                        {record.url}
                      </a>
                    </section>
                  )}

                  <section className="tda-image-list">
                    <Ant.Image.PreviewGroup
                      preview={{
                        onChange: (current, prev) =>
                          console.log(
                            `current index: ${current}, prev index: ${prev}`,
                          ),
                      }}>
                      {(record.images || []).map((it, idx) => {
                        return (
                          <div key={idx}>
                            <Ant.Image
                              width={258}
                              height={176}
                              src={it.url}
                              style={{
                                borderRadius: 10,
                                overflow: 'hidden',
                                backgroundColor: '#ddd',
                                objectFit: 'cover',
                              }}
                            />
                            <div style={{fontSize: 12, marginTop: 4}}>
                              {it.text}
                            </div>
                          </div>
                        );
                      })}
                    </Ant.Image.PreviewGroup>
                  </section>
                </>
              )}
              <Ant.Divider />
              <ShareSection
                url={
                  props.location.origin +
                  props.location.pathname +
                  props.location.search
                }
              />
              <div style={{textAlign: 'center', marginTop: 20}}>
                <Ant.Button
                  type="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    AppActions.navigate(props.location.pathname);
                  }}>
                  花絮列表
                </Ant.Button>
              </div>
            </React.Fragment>
          ) : id && !record ? (
            <div style={{marginTop: 20}}>
              <h2>無法顯示內容</h2>
              <div>內容可能未開放、已關閉、權限不足</div>
            </div>
          ) : (
            <React.Fragment>
              <div className="tda-header">
                <h2>活動花絮</h2>
                <Breadcrumb />
              </div>

              <section className="listview">
                {records.map((it) => {
                  const firstImg =
                    it.images?.length > 0
                      ? it.images[0].url
                      : '/images/site-logo.png';
                  return (
                    <Card
                      key={it.title}
                      onClick={() => {
                        AppActions.navigate(
                          `${props.location.pathname}?id=${it.id}`,
                        );
                      }}>
                      <img src={firstImg} alt="activity" />
                      <div className="card-inner">
                        <h3>
                          {it.title}
                          <span className="badge">{it.images.length}</span>
                        </h3>
                        <div className="date">
                          {it.start_date +
                            (it.end_date ? ' ~ ' + it.end_date : '')}
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </section>

              <Ant.Pagination
                total={total}
                showSizeChanger={false}
                current={filters.offset / filters.limit + 1}
                pageSize={filters.limit}
                style={{textAlign: 'right'}}
                onChange={(page, pageSize) => {
                  setFilters((prev) => ({
                    ...prev,
                    offset: (page - 1) / prev.limit,
                  }));
                }}
              />
            </React.Fragment>
          )}
        </section>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);

  th.ant-table-cell {
    display: none;
  }

  section.listview {
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;
  }

  section.document {
    margin-bottom: 20px;
    max-width: 100%;
    overflow: hidden;
  }

  section.link {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    background-color: var(--link-bgcolor);
    color: var(--link-color);
  }

  section.tda-image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
    background-color: var(--primaryLightColor);
    border solid 1px var(--primaryThBorderColor);
  }

  @media (max-width: ${Theme.breakpoint}px) {
    section.listview {
      grid-template-columns: 1fr;
    }
  }
`;

const Card = styled.div`
  display: flex;
  background-color: var(--primaryLightColor);
  cursor: pointer;
  padding: 20px;
  gap: 20px;
  border-radius: 4px;
  & > img {
    flex-basis: 150px;
    height: 100px;
    border-radius: 4px;
  }
  & > .card-inner {
    flex: 2;
    & > h3 {
      margin-bottom: 10px;
    }
    & .badge {
      padding: 2px 6px;
      background-color: #797979;
      color: white;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 12px;
      font-weight: 400;
    }
    & > .date {
      color: var(--primaryColor);
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    flex-direction: column;
  }
`;

export default withPageEntry(Activities);
